<template lang="pug">
app-collapse(title="Dados do Título")
  el-row.labelDiv
    el-col.inputDiv(:span="12")
      app-display(
        label="Nome do beneficiário:",
        :content="getValue(imovel.nomeBeneficiarioTitulo)"
      )
      app-display(
        label="N° do Título:",
        :content="getValue(imovel.numeroTitulo)"
      )
      app-display(
        label=" Município:",
        :content="getMunicipio(imovel.municipioTitulo)"
      )
    el-col.inputDiv(:span="12")
      app-display(
        label="Área:",
        :content="area"
      )
      app-display(
        label="Data de expedição:",
        :content="data"
      )
      app-display(
        :label="labelsCadastro.imovel.lote",
        :content="imovel.numeroLote"
      )
</template>
<script>
import AppDisplay from '@/components/AppDisplay'
import AppCollapse from '@/components/AppCollapse'
import utils from '@/utils/utils'
import moment from 'moment'
const {labelsCadastro} = require('@/utils/' + process.env.ESTADO + '/regrasCentral').default

export default {
  components: {
    AppDisplay,
    AppCollapse
  },
  data () {
    return {
      labelsCadastro
    }
  },
  props: {
    imovel: {
      type: Object,
      required: true
    }
  },
  methods: {
    getValue (props) {
      return props || '-'
    },
    getMunicipio (municipio) {
      return municipio.municipioTitulo ? municipio.municipioTitulo.nome : '-'
    }
  },
  computed: {
    area () {
      if (this.imovel.area === 0) {
        return '-'
      }

      return utils.format(this.imovel.areaTitulo) + ' hectare(s)'
    },
    data () {
      return this.imovel.date ? moment(this.imovel.date).format('DD/MM/YYYY') : '-'
    }
  }
}
</script>
<style lang="scss" scoped>
@media (max-width: 780px) {
  .labelDiv {
    display: flex;
    flex-direction: column;
  }

  .inputDiv {
    width: 85%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/common/InfoDadosTitulo.vue